/**
 * Tenants on the demo Firebase project (cbtv2-505113) whose demo conveniences
 * (proctor MFA bypass, static `000000` passcode) may fire.
 *
 * `school1` is the legacy catch-all slug whose Auth accounts predate the
 * tenant registry; `demo` is the tenant that resolves in
 * `aimsis_site.cbt_tenants` after the slug decision (AIMSIS-19625).
 *
 * `firestore.rules` restates this list in `hasDemoProctorBypass` — rules
 * cannot import code. Keep the two in sync.
 */
export const DEMO_BYPASS_TENANTS = ['school1', 'demo'];
//# sourceMappingURL=demo-bypass.js.map